module.exports = __webpack_public_path__ + "img/Gerenciador_de_emissoes.c8d4e52.svg";